// src/features/developers/scalar.ts
//
// The interactive reference is not part of the bundle: it weighs more than a megabyte and only
// whoever opens the «Referencia» tab needs it. Its standalone build is copied to
// `vendor/scalar/standalone.js` when the app is built (vite.scalar.ts) and loaded with a script
// tag the first time it is wanted.

interface ReferenceInstance {
  destroy?: () => void;
}

declare global {
  interface Window {
    Scalar?: {
      createApiReference: (target: HTMLElement | string, configuration: Record<string, unknown>) => ReferenceInstance;
    };
  }
}

let loading: Promise<void> | null = null;

/** Loads the script once, however many times the tab is opened. */
export const loadReferenceViewer = (): Promise<void> => {
  if (window.Scalar) return Promise.resolve();
  if (loading) return loading;
  loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${import.meta.env.BASE_URL}vendor/scalar/standalone.js`;
    script.async = true;
    script.onload = () => (window.Scalar ? resolve() : reject(new Error('viewer')));
    script.onerror = () => {
      loading = null;
      reject(new Error('viewer'));
    };
    document.head.appendChild(script);
  });
  return loading;
};

export const mountReference = (host: HTMLElement, spec: unknown, options: { dark: boolean; title: string }): ReferenceInstance =>
  window.Scalar!.createApiReference(host, {
    // The document already fetched, never a URL: it sits behind the sign-in.
    content: spec,
    darkMode: options.dark,
    hideDarkModeToggle: true, // the application owns the theme
    hideClientButton: true,
    // Their own «share / deploy» bar is for whoever edits the document, and their assistant would send
    // a specification that sits behind a sign-in to a third party.
    showDeveloperTools: 'never',
    agent: { disabled: true },
    withDefaultFonts: false, // the application's fonts, no other download
    layout: 'modern',
    documentDownloadType: 'none', // downloads live in their own tab, fetched with the session
    defaultHttpClient: { targetKey: 'shell', clientKey: 'curl' },
    metaData: { title: options.title },
  });
